import React from 'react';
import './index.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import HireUs from './components/HireUs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-slate-950 text-white">
      <Header />
      <Hero />
      <Services />
      <HireUs />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;